class BoughtTogether extends HTMLElement {
    constructor() {
        super();

        const mainPrice = this.getMainPrice();
        const mainForm = this.getMainForm();

        // Update element total price
        this.addEventListener("change", this.updateTotal.bind(this));

        // Listen price change for main product
        this.mainPriceMutation = new MutationObserver(() => {
            const input = this.querySelector('input[name="items[0][id]"]');

            this.updateTotal();

            if (this.isMainSoldout()) input.setAttribute("disabled", true);
            else input.removeAttribute("disabled");
        });

        if (mainPrice) {
            this.mainPriceMutation.observe(
                mainPrice.closest('[data-updatable="true"]'),
                { childList: true, subtree: true }
            );
        }

        // Listen variant ID change for main product
        mainForm?.addEventListener?.("change", () => {
            const variantId = mainForm.querySelector('input[name="id"]').value;

            this.querySelector('input[name="items[0][id]"]').value = variantId;
        });
    }

    collectTotal() {
        var itemsTotal = 0;

        itemsTotal += this.isMainSoldout()
            ? 0 // doesn't add main product price if product is not available
            : parseInt(this.getMainPrice()?.dataset.amount.replace(/\D/g, ""));

        this.querySelectorAll(
            '[type="checkbox"]:checked ~ .item-link .price--final'
        ).forEach((el) => {
            itemsTotal += this.parsePrice(el.dataset.amount);
        });

        return itemsTotal;
    }

    parsePrice(price) {
        const decimalSeparator = this.getPriceDecimalSeparator();

        if (decimalSeparator === ",") {
            // Replace period as thousand separator and comma as decimal separator
            price = price.replace(/\./g, "").replace(",", ".");
        } else {
            // Replace comma as thousand separator
            price = price.replace(/,/g, "");
        }
        return parseFloat(price);
    }

    updateTotal() {
        const decimalsSeparator = this.getPriceDecimalSeparator();
        const template = this.querySelector(
            'template[data-id="price"]'
        ).innerHTML;
        const total = this.collectTotal().toString();

        // formats Total according to the Locale: e.g: 123.456,78
        // const totalsWithFormat = new Intl.NumberFormat(this.getLocalization(), {
        //     style: 'currency',
        //     currency: this.getCurrencyCode(),
        // }).format(total/100);

        // replace currecny code with currecny symbol
        // const totalWithCurrencySymbol = totalsWithFormat.replace(
        //     this.getCurrencyCode(),
        //     this.getCurrencySymbol()
        // );

        // this.querySelector(".summary .price--final").outerHTML =
        //     template.replaceAll(
        //         this.getCurrencySymbol() + this.getSamplePrice(),
        //         totalWithCurrencySymbol.replace(/\s/g, '')
        //     );

        // current way collect the Total without formatting the numbers
        var int, dec;
        [int, dec] = this.getSamplePrice().split(decimalsSeparator);
        this.querySelector(".summary .price--final").outerHTML = template
            .replaceAll(int, total.slice(0, total.length - dec.length))
            .replaceAll(dec, total.slice(-dec.length));
    }

    getMainPrice() {
        return document.querySelector(".product-section .price--final");
    }

    getMainForm() {
        return document.querySelector(".product-section product-form");
    }

    isMainSoldout() {
        return !!this.getMainPrice().closest(".price--sold-out");
    }

    getLocalization() {
        return `${window.Shopify.locale}-${window.Shopify.country}`; // de-DE, en-US etc;
    }

    getCurrencyCode() {
        return window.Shopify.currency.active; // EUR, USD etc;
    }

    getCurrencySymbol() {
        return this.getMainPrice()?.dataset.currency; // $, €, £ etc;
    }

    getSamplePrice() {
        return this.querySelector('template[data-id="price"]')?.dataset
            .priceSample;
    }

    getPriceDecimalSeparator() {
        if (this.getSamplePrice().indexOf(",") !== -1) return ",";

        return ".";
    }
}

customElements.define("bought-together", BoughtTogether);
